import React from 'react';
import PropTypes from 'prop-types';
import Header from '../Header';
import Footer from '../Footer';

import './style.scss';

const Layout = ({ cart, children, currentRoute }) =>
  <div>
    <Header currentRoute={currentRoute} cart={cart} />
    <div className="layout">
      {children}
    </div>
    <Footer />
  </div>;

Layout.propTypes = {
  children: PropTypes.any.isRequired,
  currentRoute: PropTypes.string,
  cart: PropTypes.shape({
    quantity: PropTypes.number.isRequired,
    sum: PropTypes.number.isRequired,
  }).isRequired,
};

export default Layout;



// WEBPACK FOOTER //
// ./src/components/ui/Layout/index.js